import React from 'react';
export var SessionBookmarkIcon = function SessionBookmarkIcon(_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 20 27"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.49609 3.5V22.2935L9.2001 18.728C9.68649 18.424 10.3037 18.424 10.7901 18.728L16.4961 22.2938L16.4961 3.5H3.49609ZM1.22833 1.23223C1.69717 0.763393 2.33305 0.5 2.99609 0.5H16.9961C17.6591 0.5 18.295 0.763394 18.7639 1.23223C19.2327 1.70107 19.4961 2.33696 19.4961 3L19.4961 25C19.4961 25.5453 19.2002 26.0476 18.7233 26.3119C18.2464 26.5763 17.6636 26.561 17.2012 26.272L9.99526 21.7689L2.79116 26.272C2.32876 26.561 1.74593 26.5763 1.26898 26.312C0.792024 26.0476 0.496094 25.5453 0.496094 25V3C0.496094 2.33696 0.759487 1.70107 1.22833 1.23223Z",
    fill: "#AA9B8C"
  }));
};